import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgxMasonryComponent, NgxMasonryModule } from 'ngx-masonry';

import { ButtonComponent } from '@mds/ui';
import { EpdDashboardChartsComponent } from '../epd-dashboard-charts/epd-dashboard-charts.component';
import { EpdEditSectionComponent } from '../epd-edit-section/epd-edit-section.component';
import { EpdInfoTableComponent } from '../epd-info-table/epd-info-table.component';

@Component({
  selector: 'app-epd-dashboard-content',
  standalone: true,
  imports: [
    CommonModule,
    NgxMasonryModule,
    ButtonComponent,
    EpdDashboardChartsComponent,
    EpdEditSectionComponent,
    EpdInfoTableComponent
  ],
  templateUrl: './epd-dashboard-content.component.html',
  styleUrls: ['./epd-dashboard-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdDashboardContentComponent {
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  @Input() chartsData: any[] = [];
  @Input() highcharts;
  @Input() section: any[] = [];
  @Input() tableData: any[] = [];
  @Input() canPreview = false;
  @Input() previewButtonLabel = 'Preview & Export';

  @Output() editSectionUpdated = new EventEmitter<any>();
  @Output() preview = new EventEmitter<void>();

  reloadMasonryLayout() {
    this.masonry?.reloadItems();
    this.masonry?.layout();
  }
}
